module.exports = __webpack_public_path__ + "img/hr-V-R-5-load-connect-shadow.1e25e32a.png";